import React, { useContext, useState, useEffect } from "react";
import { navBarContext, authContext } from "./context/context";
import { useNavigate } from "react-router-dom";
import Settings from "./Settings";
import {
  StartupButton,
  StartupProfile,
  Loading,
  CompleteYourProfile,
  BugTab,
  FloatingButtons,
  Viewer,
} from "@peterfosso/prairi-components";
import {
  query,
  collection,
  db,
  where,
  getDocs,
  getDoc,
  doc,
  updateDoc,
} from "../firebase/firebaseApp";
import { useMediaQuery } from "react-responsive";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase/firebaseApp";
import { sendBugEmails, useWindowDimensions } from "../utils";
import Rocket from "../assets/stage.gif";

const DataProfileStartup = (props) => {
  const { navBarHeight } = useContext(navBarContext);
  const { currentUser } = useContext(authContext);
  const [docId, setDocId] = useState(null);
  const [dataFetched, setDataFetched] = useState(false);
  const [currentUserData, setCurrentUserData] = useState(null);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [screenshotUrl, setScreenshotUrl] = useState(""); //for bug report
  const [bugEmail, setBugEmail] = useState("");
  const [bugText, setBugText] = useState("");
  const [bugError, setBugError] = useState(null);
  const { width, height } = useWindowDimensions();
  const [showButtons, setShowButtons] = useState(true);
  let navigate = useNavigate();

  const redirectToLogin = () => {
    navigate("/login"); // Redirect to the login page
  };

  const redirectToForms = () => {
    //search for current position of the user in the forms
    navigate("/startupregistration");
  };

  const handleUpload = (e) => {
    return new Promise((resolve, reject) => {
      const selectedFile = e.target.files[0];

      const storageRef = ref(storage, `bugs/${selectedFile.name}`);
      const uploadTask = uploadBytesResumable(storageRef, selectedFile);

      uploadTask.on(
        "state_changed",
        null, // Manejador de progreso (puedes dejarlo como `null` si no necesitas reportarlo)
        (error) => {
          // Manejador de error
          console.error("Upload failed:", error);
          reject(error);
        },
        async () => {
          // Manejador de éxito
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          resolve(downloadURL);
          console.log("uploaded correctly");
          setScreenshotUrl(downloadURL);
        }
      );
    });
  };

  const handleBugText = (e) => {
    const value = e.target.value;
    setBugText(value);
    if (value !== "") {
      setBugError("");
    }
  };

  const handleBugEmail = (e) => {
    const value = e.target.value;
    setBugEmail(value);
    if (value !== "") {
      setBugError("");
    }
  };

  const validateFields = () => {
    if (!bugText || bugText.trim() === "") {
      setBugError("Please describe the bug.");
      return false;
    }
    return true;
  };
  const handleUploadAndSendEmail = async (file) => {
    try {
      if (!validateFields()) return;

      let uploadedUrl = screenshotUrl;
      if (file) {
        uploadedUrl = await handleUpload({ target: { files: [file] } });
      }

      console.log(`screenshotUrl ${uploadedUrl}`);
      sendBugEmails(
        currentUserData.email,
        currentUserData.contactName,
        bugText,
        "data profile startup",
        uploadedUrl || ""
      );
    } catch (error) {
      console.error("Error uploading file or sending email:", error);
    }
  };

  useEffect(() => {
    if (dataFetched && !currentUser) {
      redirectToLogin();
    }
  }, [currentUser]);

  useEffect(() => {
    if (currentUser) {
      setDocId(currentUser.uid);
    }
  }, [currentUser]);

  const getDataFromUser = async () => {
    try {
      // Get user data from email
      const { email } = currentUser;
      const q = query(collection(db, "users"), where("email", "==", email));
      const querySnapshot = await getDocs(q);
      let userData;
      let userId;
      querySnapshot.forEach((doc) => {
        userData = doc.data();
        userId = doc.id;
      });
      setCurrentUserData(userData);
      return { userData, userId };
    } catch (error) {
      //console.log("error in getDataFromUser");
    }
  };

  const fetchData = async () => {
    try {
      if (currentUser) {
        await getDataFromUser(); // Pass the UID from currentUser
        setDataFetched(true);
      }
    } catch (error) {
      //console.log('error fetching data' + error);
    }
  };

  useEffect(() => {
    fetchData();
    //console.log("data fetched?" + JSON.stringify(dataFetched))
    //console.log(currentUserData)
  }, [currentUser]);

  const [showSettings, setShowSettings] = useState(false);
  const handleSettings = () => {
    setShowSettings(true);
    navigate("/settings");
  };

  if (!dataFetched) {
    return (
      <div
        id="newMatch__"
        style={{
          marginTop: navBarHeight,
          marginBottom: navBarHeight + 30,
          width: "100%",
          minWidth: "366px",
          padding: "2%",
        }}
      >
        <Loading />
      </div>
    );
  }

  return (
    <div
      id="newMatch__"
      style={{
        marginTop: navBarHeight,
        marginBottom: navBarHeight + 10,
        width: "100%",
        minWidth: "366px",
        
      }}
    >
      {currentUserData && (
        <BugTab
          email={currentUserData.email}
          name={currentUserData.contactName}
          setEmail={handleBugEmail}
          setText={handleBugText}
          submit={(file) => handleUploadAndSendEmail(file)}
          error={bugError}
          handleFileChange={handleUpload}
        />
      )}
      <section
        id="newMatch__container"
        className={`
        w-full

 rounded-md
        py-2.5  
        px-1
        min-w-[380px]
       `}
      >
        {dataFetched && currentUserData.formData && (
          <div>
                         {showButtons && <div className="bg-[#f2f2f2] text-black  flex items-center justify-center gap-6 py-2 px-20">
                <p className="text-sm">This is how your profile will appear to investors</p>
                <button className="border border-black rounded-full px-4 py-1" onClick={() => setShowButtons(false)}> OK, looks good</button>
                <p className="underline cursor-pointer" onClick={() => navigate("/startupregistration")}>Edit Data Profile</p>
              </div>}
              {!showButtons && <div className="flex w-full items-center justify-center">
                <div className="text-center items-center text-greenPrairi text-lg my-2 w-2/3">
                  <img src={Rocket} className="w-8 pt-2 mr-4 inline" alt="rocket" />
                  Now go back to building the next big thing, we'll let you
                  know when investors come knocking.
                </div>
              </div>}
            <div className="flex pt-1 gap-2">

                <div className="overflow-y-auto pl-2 flex-1 max-h-[80vh]" style={{ maxHeight: height*0.7  }} >
              <StartupProfile
                basic
                isMobile={isMobile}
                startup={currentUserData}
                contact
                mock
              />
              </div>

              {!isMobile && <Viewer
                src={currentUserData.formData.company.deck}
                h={height * 0.8}
                w={width * 0.6}
              />}
              {!isMobile && <FloatingButtons mock status="archived" />}
            </div>
          </div>
        )}
      </section>
      {dataFetched && (
        <CompleteYourProfile
          open={
            !currentUserData.formData ||
            (!currentUserData.formData.matching.completed &&
              currentUserData.formData.company.deck !== "")
          }
          click={redirectToForms}
        />
      )}
    </div>
  );
};
export default DataProfileStartup;
